module.exports = __webpack_public_path__ + "static/img/arnergy-5000X.20b2821.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arnergy-5000X.png
// module id = 3019
// module chunks = 1